import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";

const SearchContext = createContext(null);

// Default placeholder used for pages that don't set their own (Dashboard, Billing,
// Bulk Orders, Team, Settings). Reminds the user the top bar is a global search
// that works from ANY tab.
const DEFAULT_PLACEHOLDER = "Search everything — Orders · Customers · Inventory · Users…";

export function SearchProvider({ children }) {
  const [query, setQuery] = useState("");
  const [placeholder, setPlaceholder] = useState(DEFAULT_PLACEHOLDER);
  const location = useLocation();

  // Reset the search query AND the placeholder on every route change. Pages that
  // want a tab-specific placeholder call setPlaceholder(...) in their own mount effect
  // (runs right after this one), so the more-specific hint wins on Orders/Customers/Inventory/Users.
  useEffect(() => {
    setQuery("");
    setPlaceholder(DEFAULT_PLACEHOLDER);
  }, [location.pathname]);

  const value = useMemo(() => ({ query, setQuery, placeholder, setPlaceholder }), [query, placeholder]);
  return <SearchContext.Provider value={value}>{children}</SearchContext.Provider>;
}

export function useSearch() {
  const ctx = useContext(SearchContext);
  if (!ctx) throw new Error("useSearch must be used inside <SearchProvider>");
  return ctx;
}
